import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../../../routing/routes";
import _environment from "../../../../_environment/_environment";
import CustomCheckbox from "./CustomCheckbox";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  disabled?: boolean;
  value: any;
  errors: any;
  touched: any;
  onChange?: any;
  onBlur: any;
  form: any;
}

const PrivacyConsentCheckbox = ({
  disabled,
  value,
  errors,
  touched,
  onChange,
  onBlur,
  form,
  ...props
}: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // console.log("[CustomInputText] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // console.log("[CustomInputText] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <CustomCheckbox
      label={t("gdpr.signup", {
        anchor: `<a href="${_environment.baseURL}${ROUTES.PRIVACY_POLICY}"
                target="_blank"
            title="${t("footer.links.privacyPolicy")}">${t("footer.links.privacyPolicy")}</a>`,
      })}
      name="privacy_policy_consent"
      id="privacy_policy_consent"
      disabled={disabled}
      isHtml={true}
      className={"gdpr"}
      form={form}
      onBlur={onBlur}
      value={value}
      errors={errors}
      touched={touched}
    />
  );
};
export default PrivacyConsentCheckbox;
